import { COLORS } from "../lib/colors";

export default function ActivityFeed({ activity }) {
  if (!activity || activity.length === 0) {
    return (
      <div>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: COLORS.text, marginBottom: 12 }}>
          Recent Activity
        </h3>
        <p style={{ fontSize: 13, color: COLORS.textMuted }}>No activity yet.</p>
      </div>
    );
  }

  return (
    <div>
      <h3 style={{ fontSize: 16, fontWeight: 700, color: COLORS.text, marginBottom: 12 }}>
        Recent Activity
      </h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {activity.map((a, i) => {
          const icon = a.type === "search" ? "🔍" : "👁";
          const action = a.type === "search" ? "searched for" : "viewed";
          const time = (a.created_at || "").slice(0, 16).replace("T", " ");

          return (
            <div key={i} style={{ fontSize: 13, color: COLORS.textSecondary }}>
              {icon} <strong>{a.email}</strong> {action} <strong>{a.detail}</strong>
              <span style={{ color: COLORS.textMuted, marginLeft: 8 }}>{time}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
